export default __webpack_public_path__ + "static/media/buddy2.9b092791.jpg";